import React, { useState } from 'react'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import TruncateText from 'housecall-ui/dist/utils/TruncateText'
import ExpandMoreIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandMore'
import ExpandLessIcon from 'housecall-ui/dist/IconsAndImages/Icons/ExpandLess'

const styles = {
  fullText: {
    whiteSpace: 'pre-line',
  },
}

const TruncatedText = ({
  classes,
  lines,
  moreText = '...Show more',
  lessText = 'Show less',
  children = '',
  variant = "body2",
  showExpandIcon = false,
  wordBreak,
  ...props
}) => {
  const [truncate, setTruncate] = useState(true)
  const [isTruncated, setIsTruncated] = useState(false)

  const onClickExpand = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setTruncate(!truncate)
  }

  const renderTruncatedTextControls = () => {
    if (isTruncated) {
      return (
        <Link onClick={(event) => onClickExpand(event)} component="button" underline="none">
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography color="primary" variant="body2">
                {truncate ? moreText : lessText}
              </Typography>
            </Grid>
            {showExpandIcon && (
              <Grid item>{truncate ? <ExpandMoreIcon color="primary" /> : <ExpandLessIcon color="primary" />}</Grid>
            )}
          </Grid>
        </Link>
      )
    }
    return null
  }

  return (
    <HousecallThemeProvider>
      <Typography variant={variant} {...props}>
        <TruncateText
          truncate={truncate}
          maxLines={lines}
          onTruncate={(res) => setIsTruncated(res)}
          wordBreak={wordBreak}
          className={classes.fullText}
        >
          {children}
        </TruncateText>
      </Typography>
      {renderTruncatedTextControls()}
    </HousecallThemeProvider>
  )
}

export default withStyles(styles)(TruncatedText)
